import axios from 'axios';
import api from '../api'; // your configured axios instance for authenticated requests
import { API_URL } from '../config';

export async function loginUser({ email, password }) {
  try {
    console.log('API_URL:', API_URL);
    console.log('Sending login:', { email, password });
    
    // Use raw axios for login since we don't have a token yet
    const response = await axios.post(`${API_URL}/auth/login`, {
      email,
      password
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });

    const data = response.data;
    if (data.token) {
      localStorage.setItem('token', data.token);
    }
    return data;
  } catch (error) {
    console.error('Login error:', error);
    if (error.response?.data) {
      throw new Error('Login failed: ' + (error.response.data.message || JSON.stringify(error.response.data)));
    }
    throw error;
  }
}

export async function sendResetEmail(email) {
  // Use raw axios since no token is needed
  const response = await axios.post(`${API_URL}/auth/forgot-password`, {
    email
  }, {
    headers: { 'Content-Type': 'application/json' }
  });
  return response.data;
}

export async function resetPassword(token, password) {
  // Use raw axios since no token is needed
  const response = await axios.post(`${API_URL}/auth/reset-password`, {
    token,
    password
  }, {
    headers: { 'Content-Type': 'application/json' }
  });
  return response.data;
}

export async function getHrStaff() {
  try {
    // Use your configured api instance (requires token)
    const response = await api.get('/employees/hr-staff');
    return response.data;
  } catch (error) {
    console.error('Error fetching HR staff:', error);
    throw error;
  }
}

export async function changePassword(oldPassword, newPassword) {
  try {
    // Use your configured api instance (requires token)
    const response = await api.post('/auth/change-password', {
      oldPassword,
      newPassword
    });
    return response.data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
}